module.exports = __webpack_public_path__ + "media/img/ticketinhotel-h-020b6cbda6e36fa56f107f0a52e864e6.png";